import React from 'react';
import DbCreator from '../CreateDbGroup/pageBody';

// CreateDb page - uses DbCreator component in 'db' mode
const CreateDb = () => {
    return <DbCreator mode="db" />;
};

export default CreateDb;
